var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"last-calls-container"},[_c('b-row',[_c('span',[_vm._v("LAST CALLS :")])]),_vm._v(" "),_c('b-row',{staticClass:"calls-display"},_vm._l((_vm.callhistory),function(call){return _c('div',[_c('div',{staticClass:"call-value-as-number"},[_c('span',[_vm._v(_vm._s(call))])])])}))],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a546714c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/uk/tombola-roulette/_components/last-calls/last-calls.html
// module id = null
// module chunks = 